import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { LoginModalChangePasswordComponent } from './login/login.component';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { AppUiModule } from '../../ui/app-ui.module';
import { RecoveryAccessComponent } from './recovery-access/recovery-access.component';
import { SendEmailSuccessComponent } from './send-email-success/send-email-success.component';
import { ChangePasswordIncorrectComponent } from './change-password-incorrect/change-password-incorrect.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ChangePasswordSuccessComponent } from './change-password-success/change-password-success.component';
import { InterceptorLoginComponent } from './interceptor-login/interceptor-login.component';
import { LoginV2Component } from './login-v2/login-v2.component';
import { LoginV2CallbackComponent } from './login-v2-callback/login-v2-callback.component';
import { LogoutV2Component } from './logout-v2/logout-v2.component';

@NgModule({
    declarations: [
        LoginModalChangePasswordComponent,
        LoginComponent,
        RecoveryAccessComponent,
        SendEmailSuccessComponent,
        ChangePasswordIncorrectComponent,
        ChangePasswordComponent,
        ChangePasswordSuccessComponent,
        InterceptorLoginComponent,
        LoginV2Component,
        LoginV2CallbackComponent,
        LogoutV2Component,
    ],
    imports: [CommonModule, ReactiveFormsModule, AuthRoutingModule, AppUiModule, FormsModule],
    exports: [LoginComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthModule {}
